'use client';

import { type ReactNode, useEffect } from 'react';
import { SimilarGamesCarousel, type SimilarGamesCarouselFilter } from '../SimilarGamesCarousel/SimilarGamesCarousel';
import type { GameLayout } from '../types/types';

type GamePlayPageComponentProps = {
  children: ReactNode;
  layout: GameLayout;
  carouselCategory?: SimilarGamesCarouselFilter;
  gameName?: string;
};

function GamePlayPageComponent({ children, carouselCategory, layout, gameName }: GamePlayPageComponentProps) {
  const layoutConfig = {
    full: {
      container: 'absolute top-0 left-0 w-full h-full z-50 bg-background',
      innerWrapper: 'w-full h-full',
    },
    frame: {
      container: 'll-container-inner flex flex-col items-center justify-start py-8 px-9',
      innerWrapper: 'overflow-hidden w-full',
    },
  };

  useEffect(() => {
    if (layout === 'full') {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [layout]);

  const showDesktopCarousel = layout === 'frame';

  return (
    <div className="ll-grid-container min-h-screen">
      <div className={layoutConfig[layout].container}>
        <div className={layoutConfig[layout].innerWrapper}>{children}</div>
        {showDesktopCarousel && carouselCategory && <SimilarGamesCarousel filter={carouselCategory} excludeGameId={gameName} className="w-full mt-6" />}
      </div>
    </div>
  );
}

export { GamePlayPageComponent };
